
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_22510_19128)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.157.571C.518.571 0 1.107 0 1.767v8.269c0 .66.518 1.196 1.157 1.196h5.34v2.77h-1.34c-.38 0-.69.319-.69.713 0 .394.31.713.69.713h6.498c.381 0 .69-.319.69-.713a.702.702 0 00-.69-.713h-1.34v-2.77h4.528c.639 0 1.157-.536 1.157-1.196V1.767c0-.66-.518-1.196-1.157-1.196H1.157zm7.777 10.66H7.878v2.77h1.056v-2.77zm5.685-1.426V1.998H1.381v7.807h13.238z","fill":"#9DA7B2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_22510_19128"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    